import HomePagePromotor from './HomePagePromotor';

export default HomePagePromotor;
